import { useEffect } from 'react';

export type StaleAwareContext<T> = {
  data: T | null;
  lastLoaded: Date | null;
  reload: () => void;
  isLoading: boolean
};

const STALE_THRESHOLD_MINUTES = 10;

const isStale = (loaded: Date | null) => {
  if (!loaded) return true;
  const diff = (Date.now() - loaded.getTime()) / 1000 / 60;
  return diff > STALE_THRESHOLD_MINUTES;
};

export function useStaleAwareDataContext<T>(context: StaleAwareContext<T>) {
  const { data, lastLoaded, reload, isLoading } = context;
  
  useEffect(() => {
    if (!data) {
      reload();
    }
  }, []);

  useEffect(() => {
    if (isStale(lastLoaded)) {
      reload();
    }
  }, [lastLoaded, reload]);

  return {data, lastLoaded, reload, isLoading};
}